export const DECIMAL_NUMBER_PATTERN = '^[0-9]+([\\,\\.][0-9]+)?$'

export const discountRateToPercent = rate => Math.round(rate * 10000) / 100

export const formatDiscount = code => {
  const attrs = code.attributes
  if (attrs.type === 'PercentOffDiscountCode') {
    return `${discountRateToPercent(attrs.discount_rate)}% off`
  }
  if (attrs.type === 'AmountOffDiscountCode') {
    const cents = attrs.discount_amount?.cents || 0
    const dollars = cents / 100
    return `$${cents % 100 === 0 ? dollars : dollars.toFixed(2)} off`
  }
  if (attrs.type === 'FreeShippingDiscountCode') {
    return 'Free shipping'
  }
  return ''
}
